import './Project.css';
import { useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router';
import { PROJECTS } from '../../config/projects';
import SEOHead from '../../components/SEOHead';
import { getCanonicalUrl } from '../../config/seo';

function Project() {
  const { id } = useParams();
  const navigate = useNavigate();

  // Find project by ID or link
  const project = PROJECTS.find(
    p => p.id.toString() === id || p.link.replace('/project/', '') === id
  );

  useEffect(() => {
    if (!project) {
      navigate('/404');
      return;
    }
    document.title = `${project.brand} | Phoenix Unity Designs`;
  }, [project, navigate]);

  if (!project) {
    return null;
  }

  const canonicalUrl = getCanonicalUrl(`/project/${project.link.replace('/project/', '')}`);

  return (
    <>
      <SEOHead
        title={`${project.brand} | Phoenix Unity Designs`}
        description={project.description}
        keywords={`web design, web development, ${project.brand}, branding`}
        canonical={canonicalUrl}
        ogUrl={canonicalUrl}
        ogTitle={project.brand}
        ogDescription={project.description}
      />
      <main id="main-content" tabIndex="-1" className='Project page-container'>
      <div className='project-content-full'>
        <div className='container'>
          <div className="row justify-content-md-center">
            <div className="col-md-12 col-lg-8">
              <h5>{project.brand}</h5>
              <h1>{project.pageTitle}</h1>
              <p className='description'>{project.description}</p>
            </div>
          </div>
        </div>
        {project.content}
        {project.testimonials?.length > 0 && (
          <div className='full-width-color mt-0'>
            <div className='container testimonials-section'>
              <div className="row justify-content-md-center">
                <div className="col-md-12 col-lg-8">
                  {project.testimonials.map((testimonial, index) => (
                    <blockquote key={index} className="testimonial blockquote">
                      <p className="quote">{testimonial.quote}</p>
                      {testimonial.author && (<figcaption className="author blockquote-footer">{testimonial.author}</figcaption>)}
                    </blockquote>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className='container contact-us-section'>
          <div className="row justify-content-md-center">
            <div className="col-md-12 col-lg-8">
              Have a project that needs some love? 
              <br />
              <Link to="/contact" className="btn btn-primary btn-accent" anim="sheen">Reach out!  &raquo;</Link>
            </div>
          </div>
        </div>
      </div>
    </main>
    </>
  );
}

export default Project;
